import React, { useState, useEffect, useCallback } from 'react';
import CreateOrganization from '../../components/CreateOrganization';
import Notification from '../../components/Notification';
import useApi from '../../api/useApi';
import { orgTypes } from '../../Constants';

function Table() {
  const [openCreate, setOpenCreate] = useState(false);
  const [selectedOrg, selectOrg] = useState({ id: '', name: '' });
  const [{ isLoading, isError, data }, getData] = useApi();
  const [organizations, setOrganizations] = useState([]);
  const [state, deleteOrg] = useApi();
  const [action, setAction] = useState('');
  const [notification, setNotification] = useState(false);
  const [type, setType] = useState(null);
  const [message, setMessage] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [formData, setFormData] = useState({ q: '', type: '', isActive: '' });
  const [onClose, setOnClose] = useState(false);

  useEffect(() => {
    getData('/organizations', 'GET');
  }, []);
  const handleInputBoolean = useCallback((e) =>
    setFormData({
      ...formData,
      [e.target.name]: e.target.value === 'true' ? true : e.target.value === 'false' ? false : '',
    })
  );

  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));

  useEffect(() => {
    if (organizations.length <= 0) {
      return;
    }

    if (formData.q === '' && formData.type === '') {
      setFilteredData(organizations);
    }

    let z = organizations;

    if (formData.type) {
      z = z.filter((item) => item.organizationType === formData.type);
    }

    if (formData.q) {
      z = z.filter((x) => {
        const normalizedQuery = formData.q.toLowerCase();
        return x?.organizationName?.toLowerCase().indexOf(normalizedQuery) >= 0;
      });
    }
    if (formData.isActive) {
      z = z.filter((item) => item.isActive);
    }
    if (formData.isActive === false) {
      z = z.filter((item) => !item.isActive);
    }

    if (z.length > 0) setFilteredData(z);
    else setFilteredData([]);
  }, [formData]);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setOrganizations(data.organization);
      setFilteredData(data.organization);
    }

    if (isError) {
      setType('error');
      setMessage('Unable to fetch Organization Record');
      setNotification(!notification);
    }
  }, [isLoading, isError, data]);

  const toggleOpenCreate = () => {
    setOpenCreate((prev) => !prev);
  };

  const createNotification = (types, messages) => {
    setType(types);
    setMessage(messages);
    setNotification(!notification);
  };

  const getOrgType = (orgCode) => {
    const x = orgTypes.filter((org) => org.id == orgCode);
    return x[0]?.value;
  };

  const handleDelete = () => {
    deleteOrg(`/organization/${selectedOrg.id}`, 'DELETE');
  };

  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      getData('/organizations', 'GET');
      setType('success');
      setMessage('Organization Record deleted successfully');
      setNotification(!notification);
      setOnClose(false);
    }
    if (state.isError) {
      setType('error');
      setMessage('Unable to delete Organization Record');
      setNotification(!notification);
      setOnClose(false);
    }
  }, [state]);

  const refreshList = () => {
    getData('/organizations', 'GET');
    // toggleOpenCreate();
  };

  const hideNotification = (msg) => {
    setNotification(false);
  };

  return (
    <>
      {notification && <Notification type={type} message={message} hideNotification={hideNotification} />}
      {onClose && (
        <div
          className="flex justify-center items-center h-full w-full fixed z-20"
          style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
        >
          <div className="bg-white w-full md:w-3/12 px-2 text-sm block m-auto rounded-2xl relative">
            <span className="block p-4 font-bold border-b text-textBlue1">Delete Organization</span>
            <img
              src="assets/img/Close.svg"
              className="absolute top-3 right-3 h-3 cursor-pointer"
              alt=""
              onClick={() => setOnClose(false)}
            />
            <span className="block text-center text-sm my-8" style={{ color: '#9B9B9B' }}>
              Do you want to delete Organization {selectedOrg.name}?
            </span>
            <div className="mb-6 font-bold float-right mr-8 w-2/3">
              <div className="w-1/3" />
              <div className="w-full md:w-2/3 flex">
                <button
                  type="submit"
                  className="mt-1 lg:mt-0 lg:w-max w-auto border px-8 py-4 rounded-3xl text-xs mr-2 focus:outline-none flex justify-center items-center h-7"
                  onClick={() => {
                    setOnClose(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="mt-1 lg:mt-0 w-auto lg:w-max border px-8 py-4 rounded-3xl text-xs font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                  onClick={handleDelete}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {openCreate && (
        <CreateOrganization
          handleClose={toggleOpenCreate}
          notification={createNotification}
          action={action}
          selectedOrg={selectedOrg.id}
          refreshList={() => refreshList()}
        />
      )}
      <div
        className="mt-10 md:mt-0 lg:m-8 static md:fixed bg-white w-full sm:w-10/12 overflow-scroll lg:overflow-hidden nav_org"
        style={{
          filter: openCreate && 'blur(2px)',
        }}
      >
        <div className="h-16 sm:h-40">
          <div
            className=" pt-4 md:pt-8 lg:flex block sm:block sm:justify-between text-left sm:text-center lg:text-left w-tableWidth m-auto "
            // style={{ paddingTop: '4vh' }}
          >
            <span className="text-textBlue1 font-bold text-lg">Organizations</span>

            <div className="flex float-right mt-0">
              <button
                className="mt-1 lg:mt-0 w-max border px-3 py-1 rounded-md text-xs mx-0 sm:mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  setAction('create');
                  toggleOpenCreate();
                }}
              >
                <img src="assets/img/Create.svg" className="h-3 mr-2 " alt="" />
                CREATE
              </button>

              <div className="absolute top-0 right-2 md:static mt-2 lg:mt-0 z-40 h-6 md:h-full w-2/3 md:w-full text-xs lg:w-max border bg-transparent px-5 rounded-sm ml-3 flex justify-between items-center rounded-xl">
                <input
                  type="text"
                  placeholder="Search Organization"
                  className="text-textBox bg-transparent focus:outline-none"
                  style={{ borderColor: '#e6e6e6' }}
                  value={formData.q}
                  name="q"
                  onChange={handleInputChange}
                />
                <img src="assets/img/Search.png" className="h-4 ml-2 " alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="tbl">
          <div className="bg-white w-tableWidth m-auto mb-3" style={{ minWidth: '900px' }}>
            <div className="bg-white w-full flex border" style={{ borderColor: '#e6e6e6' }}>
              <div className="px-8 py-2 items-center flex w-full relative bg-primary text-white text-left text-xs font-bold">
                <div classname="width_org" style={{ width: `${100 / 8}%` }}>
                  NAME
                </div>
                <div style={{ width: `${100 / 8}%` }}>HEADQUARTER</div>
                <div className="py-1" style={{ width: `${100 / 8}%` }}>
                  <div className="relative flex">
                    <svg
                      className="w-3 h-2 absolute top-1 right-2 my-3 md:my-2 mr-3 sm:mt-4 sm:mx-2 sm:mb-4  pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 412 232"
                    >
                      <path
                        d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                        fill="#ffffff"
                        fillRule="nonzero"
                      />
                    </svg>
                    <select
                      value={formData.type}
                      name="type"
                      className="border w-full font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-8 pl-1 lg:pl-3 lg:pr-4 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md"
                      onChange={handleInputChange}
                      style={{ borderColor: '#e6e6e6' }}
                    >
                      <option value="">TYPE</option>
                      {orgTypes.map((item) => (
                        <option value={item.id}>{item.value}</option>
                      ))}
                    </select>
                  </div>
                </div>
                {/* <div className=" py-5 text-sm font-bold" style={{ width: `${100 / 6}%` }}>
                  SPOC
                </div> */}
                <div className="pl-2" style={{ width: `${100 / 8}%` }}>
                  EMAIL
                </div>
                <div style={{ width: `${100 / 8}%` }}>MOBILE</div>
                <div style={{ width: `${100 / 8}%` }}>
                  {' '}
                  <div className="relative inline-flex">
                    <svg
                      className="w-3 h-2 absolute top-0 right-0 m-3 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 412 232"
                    >
                      <path
                        d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                        fill="#ffffff"
                        fillRule="nonzero"
                      />
                    </svg>
                    {console.log('dance', formData)}
                    <select
                      value={formData.isActive}
                      name="isActive"
                      className="border font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-8 pr-5 pl-2 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md"
                      onChange={handleInputBoolean}
                      style={{ borderColor: '#e6e6e6' }}
                    >
                      <option value="">STATUS</option>
                      <option value="true">ACTIVE</option>
                      <option value="false">INACTIVE</option>
                    </select>
                  </div>
                </div>
                <div style={{ width: `${100 / 8}%` }}>LAST MODIFIED</div>
                <div style={{ width: `${100 / 8}%` }}>ACTION</div>
                {/* <img src="assets/img/Filter.svg" className="w-5 absolute top-5 right-3" /> */}
              </div>
            </div>
            {!isLoading ? (
              <div className="hideScroll " style={{ overflowY: 'scroll', height: '68vh' }}>
                {filteredData.map((item) => (
                  <div
                    className="my-1 px-8 flex
                  relative hover:border-indigo-200 focus-within:border-indigo-200 text-role py-2 items-center justify-center text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs "
                    style={{ border: '0.5px solid #C0C0C0', boxSizing: 'border-box', borderRadius: '4px' }}
                  >
                    {/* <input
                      type="checkbox"
                      className="absolute left-3 top-5"
                      checked={selectedOrg === item.id}
                      onChange={() => {
                        selectedOrg === item.id ? selectOrg('') : selectOrg(item.id);
                      }}
                    /> */}

                    <div
                      // className="px-3"
                      // className="text-role py-2 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs"
                      style={{ width: `${100 / 8}%` }}
                    >
                      {item?.organizationName}
                    </div>
                    <div
                      // className="text-center"
                      // className="text-role py-2 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs"
                      style={{ width: `${100 / 8}%` }}
                    >
                      {item?.Address.state}
                    </div>
                    <div
                      // className=" text-center"
                      // className="text-role py-2 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs"
                      style={{ width: `${100 / 8}%` }}
                    >
                      {getOrgType(item?.organizationType)}
                    </div>
                    {/* <div
                      className="text-role py-4 overflow-ellipsis overflow-hidden whitespace-nowrap text-sm uppercase"
                      style={{ width: `${100 / 7}%` }}
                    >
                      {''}
                    </div> */}
                    <div
                      // className="pr-4"
                      className="text-role py-2 pr-3 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs"
                      style={{ width: `${100 / 8}%` }}
                    >
                      {item?.email}
                    </div>
                    <div
                      // className="pl-2"
                      // className="ml-10"
                      // className="text-role py-2 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs"
                      style={{ width: `${100 / 8}%` }}
                    >
                      {item?.contactNo}
                    </div>
                    <div
                      className="text-role py-2 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs"
                      style={{ width: `${100 / 8}%` }}
                    >
                      {item?.isActive ? (
                        <p className="text-green-700 "> ACTIVE</p>
                      ) : (
                        <p className="text-red-700 "> INACTIVE</p>
                      )}
                    </div>
                    <div
                      className="text-role py-2 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs"
                      style={{ width: `${100 / 8}%` }}
                    >
                      {new Date(item?.updatedAt).getDay() === 0
                        ? `${new Date(item?.updatedAt).getHours()} Hours Ago`
                        : `${new Date(item?.updatedAt).getDay()} Days Ago`}
                    </div>
                    <div className="flex" style={{ width: `${100 / 8}%` }}>
                      <img
                        src="assets/img/Edit2.svg"
                        className="h-3 mr-4 "
                        alt=""
                        onClick={() => {
                          selectOrg({ id: item?.id });
                          setAction('update');
                          toggleOpenCreate();
                        }}
                      />
                      <img
                        src="assets/img/Delete2.svg"
                        className="h-3"
                        alt=""
                        onClick={() => {
                          selectOrg({ id: item?.id, name: item?.organizationName });
                          setOnClose(true);
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Table;
